export const FAQ = {
    onLoad: function() {
        this.bindAccordion();
    },
    bindAccordion: function() {
        $('.faq-question').on('click', function() {
            let $btn     = $(this);
            let $answer  = $btn.next('.faq-answer');
            let isOpen   = $answer.hasClass('is-open');

            let $accordion = $btn.closest('.faq-accordion');
            $accordion.find('.faq-answer').removeClass('is-open');
            $accordion.find('.faq-question').attr('aria-expanded', 'false');

            if (!isOpen) {
                $answer.addClass('is-open');
                $btn.attr('aria-expanded', 'true');
            }
        });
    },
}


// WEBPACK FOOTER //
// ./scripts/modules/FAQ.js